(function () {
  'use strict';
  var form = document.getElementById('ardera-signup');
  if (!form) return;

  var success = document.getElementById('acs-success');
  if (success) {
    try { success.focus({ preventScroll: false }); } catch (e) { success.focus(); }
    return;
  }

  var input = form.querySelector('input[type="email"]');
  var msg = document.getElementById('acs-email-msg');
  var button = form.querySelector('button[type="submit"]');
  if (!input || !msg || !button) return;

  var buttonLabel = button.textContent;
  var pattern = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

  function showError(text) {
    msg.innerHTML = '';
    var wrap = document.createElement('div');
    wrap.className = 'acs-error';
    wrap.setAttribute('role', 'alert');
    var rule = document.createElement('span');
    rule.className = 'acs-error__rule';
    rule.setAttribute('aria-hidden', 'true');
    var body = document.createElement('div');
    var p = document.createElement('p');
    p.textContent = text;
    body.appendChild(p);
    wrap.appendChild(rule);
    wrap.appendChild(body);
    msg.appendChild(wrap);
    input.setAttribute('aria-invalid', 'true');
  }

  function resetButton() {
    delete form.dataset.submitting;
    button.removeAttribute('aria-disabled');
    button.textContent = buttonLabel;
  }

  // Client-side check only blocks clearly invalid input; Shopify performs the real submission and validation.
  form.addEventListener('submit', function (event) {
    var value = input.value.trim();
    input.value = value;
    if (!pattern.test(value)) {
      event.preventDefault();
      showError(input.getAttribute('data-invalid-message') || 'Please enter a valid email address.');
      input.focus();
      return;
    }
    if (form.dataset.submitting) { event.preventDefault(); return; }
    form.dataset.submitting = 'true';
    button.setAttribute('aria-disabled', 'true');
    var loading = button.getAttribute('data-loading-text');
    if (loading) button.textContent = loading;
  });

  input.addEventListener('input', function () {
    if (input.getAttribute('aria-invalid') === 'true') {
      input.removeAttribute('aria-invalid');
      msg.innerHTML = '';
    }
  });

  window.addEventListener('pageshow', function (event) { if (event.persisted) resetButton(); });
})();
